import moment from 'moment';
import momentTimezone from 'moment-timezone';
import Papa from 'papaparse';
import { getDefaultTimezone } from './date-time';
import { createIntl, createIntlCache, defineMessages } from 'react-intl'
import localeData from '../../public/locales/data.json';

export const obfuscatePhoneNumber = (phoneNumber) => {
  const newString = phoneNumber.substr(phoneNumber.length - 4, 4);

  return `*******${newString}`;
};

export const thumbnailImageCheck = (profileImage) => {
  const image = profileImage || {};
  return !image.thumb_url
    //? 'https://s3.amazonaws.com/shyftassets/avatar1.png'
    ? '/icons/default-profile-thumb.svg'
    : image.thumb_url;
};


const _getApplicantObject = (row, applicantsDictionary) => {
  return  applicantsDictionary[row?.coverer?.applicantId];
}

const getManagerObject = (row, applicantsDictionary, allUsers) => {
 const applc = _getApplicantObject(row, applicantsDictionary);
  if( applc !== null && applc !== undefined ){ 
    if ( applc.decider_id !== null && applc.decider_id !== undefined && applc.decider_id !== '' ) {
      const userObj = allUsers[applc.decider_id];
      if( userObj !== null && userObj !== undefined ){
        return userObj;
      }else{
        return {first_name: "User", last_name: applc.decider_id+""};
      }
    }
  }
  return '';
}



const getApprovedTime = (row, applicantsDictionary) => {
  const applc = _getApplicantObject(row, applicantsDictionary);
  if( applc !== null && applc !== undefined ){
    return applc.decided_at;
  }else{
    return '';
  }
}

const getCovererTime = (row, applicantsDictionary) => {
  const applc = _getApplicantObject(row, applicantsDictionary);
  if( applc !== null && applc !== undefined ){
    return applc.created_at;
  }else{
    return '';
  }
}

const getApplicantUserObject = (row, applicantsDictionary) => {
   const applc = _getApplicantObject(row, applicantsDictionary);
  if( applc !== null && applc !== undefined ){
    return applc.user;
  }else{
    return '';
  }
}

const allUsersDictionary = (users) => {
  let dict = {}
  users.forEach( (user) => {
      dict[user.owner_id] = user 
  }); 
  return dict;
}

export const createCsvRowData2 = (rows, headers, location, allUsers, applicantsDictionary) => {
  
  if (rows && rows.length > 0) {
    
    const usersDict = allUsersDictionary(allUsers);

    console.log("All Applicants:" + JSON.stringify(applicantsDictionary));
    console.log("All Users:" + JSON.stringify(usersDict));

    return rows.map((row, index) => {
      let applicantStatus = '';
      if(row.cover_mode === 'default') {
        applicantStatus = row.trade_status;
      }else {
        if(row.cover_mode === 'multi_applicants_picked_by_manager') {

          if( row.coverer !== null ){
            if ( row.coverer?.applicantStatus === '#a') {
                applicantStatus = 'approved';
            }else if ( row.coverer?.applicantStatus === '#p') {
                applicantStatus = 'pending';
            }else if ( row.coverer?.applicantStatus === '#d') {
                applicantStatus = 'denied';
            }
          }else{
            if( row.trade_status == 'open'){
              applicantStatus = 'posted';
            }else{
              applicantStatus = row.trade_status;
            }
          }
        }
      }

      return headers.map((header) => {
        if (Array.isArray(header.key)) {
          return header.key.map((key) => {
            return row[key];
          });
        }

        switch (header.key) {
          case 'location_name':
            return location.location_name;

          case 'formatted_address':
            if (location.formatted_address) {
              return `${location.formatted_address}`;
            }
            return 'N/A';

          case 'time_zone':
            return getDefaultTimezone();

          case 'content':
            return row[header.key] ? `${row[header.key]}` : '';

          case 'trade_status':
            return applicantStatus;

          case 'approver':
            return getManagerObject(row, applicantsDictionary, usersDict);

          case 'manager_time':
            return getApprovedTime(row, applicantsDictionary);

          case 'coverer_time':
            return getCovererTime(row, applicantsDictionary);

          case 'coverer':
            return getApplicantUserObject(row, applicantsDictionary);
         
          default:
            // console.log('default: ' + header.key + ' -> '  + row[header.key]);
            return row[header.key] ? row[header.key] : '';
        }
      });
    });
  }
  return [];
};

export const isEmptyCookie = (string) =>
  string === 'undefined' || string === 'null';

function checkForTermsUrl(setupActions) {
  // pp_url
  if (
    setupActions &&
    setupActions.meta &&
    setupActions.meta.current_location &&
    setupActions.meta.current_location.tos_url
  ) {
    return setupActions.meta.current_location.tos_url;
  }
}

export function formatTermsLinkWithLocale(setupActions, locale) {
  const url = checkForTermsUrl(setupActions)
    ? checkForTermsUrl(setupActions)
    : undefined;

  return url || `https://myshyft.com/terms.${locale}.html`;
}

export function formatPrivacyLinkWithLocale(setupActions, locale) {
  return `https://myshyft.com/privacy.${locale}.html`;
}

// For formatting response[only] props before sending to api
export const formatOnlyProps = (props) =>
  props.replace(/(\r\n|\n|\r)/gm, ' ').replace(/\s+/g, ''); // Strips string of linebreaks

export const cleanUsersArr = (users) => {
  let scrubbedUsers = [];
  // Set to empty string if server returns null position
  scrubbedUsers = users.map((user) => {
    if (user.position === null) {
      user.position = '';
    }

    return user;
  });

  return scrubbedUsers;
};

export function isNextDay(times) {
  return (
    times[1].isBefore(times[0]) ||
    times[0].isSame(times[1]) ||
    times[1].isAfter(times[0], 'date')
  );
}

export function createDateString(momentDate) {
  if (momentDate) {
    return moment(momentDate).format('MMMM D');
  }

  return 'Date';
}

export function createTimeString(date) {
  if (date) {
    return moment(date).format('LT');
  }

  return 'Time';
}

export function createTimeRangeString(times) {
  if (times && times.length > 0) {
    const startTimeText = moment(times[0]).format('LT');
    const endTimeText = moment(times[1]).format('LT');
    const startBeforeEnd = isNextDay(times);

    return `${startTimeText} to ${endTimeText} ${
      startBeforeEnd ? '(Next Day)' : ''
    }`;
  }

  return 'Time';
}

export const createFullName = ({ first_name, last_name }) =>
  `${first_name} ${last_name}`;

export const truncateString = (string, maxLength, truncateLines) => {
  const lineToTruncate = truncateLines ? string.split('\n')[0] : string;

  return lineToTruncate.length > maxLength
    ? `${lineToTruncate.substring(0, maxLength)}...`
    : lineToTruncate;
};


export class CustomText {
  constructor(locationConfig) {
    
    this.locationConfig = locationConfig;
    this.cover = { confirm: {} };
    this.approve = { confirm: {} };

    this.cover.confirm.title =
      locationConfig?.custom_text.shift_action_cover_confirm_title;
    this.cover.confirm.body =
      locationConfig?.custom_text.shift_action_cover_confirm_body;
    this.cover.confirm.yes =
      locationConfig?.custom_text.shift_action_cover_confirm_yes;

    this.approve.confirm.title =
      locationConfig?.custom_text.shift_action_approve_confirm_title;
    this.approve.confirm.body =
      locationConfig?.custom_text.shift_action_approve_confirm_body;
    this.approve.confirm.yes =
      locationConfig?.custom_text.shift_action_approve_confirm_yes;
  }

  hasCustomText() {
    return Boolean(this.locationConfig);
  }
}

